import React, { useReducer, useRef } from "react"
import { API, Auth } from "aws-amplify"
import Budget2023Reducer from "./Budget2023Reducer"
import Budget2023Context from "./Budget2023Context"
import PropTypes from "prop-types"
import axios from "axios"
import {
  getChapterParentId,
  getChapterById,
  getPartIndex,
  getChapterIndex,
  getChapterByParentAndPosition,
} from "utils/budgetUtils"
import Chapter from "./Chapter"
import Part from "./Part"
import * as amplitude from "@amplitude/analytics-browser"

import {
  SENDING_MESSAGE,
  SEND_COMPLETE,
  RESET_SEND,
  SET_FOOTER_VALUES,
  DEL_CAPITULO_SET_POSITION,
  SET_MODAL_BUDGETING_ERROR,
  REMOVE_ALL_PARTS_FROM_CHAPTER,
  IS_CONTRADICTING_PART,
  SET_LOADING_ICON,
  IS_BUDGET_CLOSED,
  SET_CLOSE_INFO,
  MOVE_PARTS_BY_CHAPTERS_ID,
  SET_DYNAMIC_ELEMENT_MODAL_IS_OPEN,
  SET_DYNAMIC_ELEMENT_SELECTED,
  SET_DYNAMIC_ELEMENT_PROJECT_ID,
  EXTRAS_AND_CONTRADICTIONS,
  SET_GENERAL_UPDATE,
  CERTIFICATION_LOADING,
  SET_CHAPTER_CERT_IN_PROGRESS,
  CERT_DRAFT_SET_PARTIDA,
  SET_MARGIN_MODAL,
  SET_MARGIN_MODAL_INITIAL_VALUE,
} from "../types"
import { CORE_URL } from "utils/functions"
import { useLocation } from "react-router-dom"
import { useExtrasAndContradictionsContext } from "context/extrasAndContradictions/ExtrasAndContradictionsContext"
import { isNil } from "lodash"
import { useSnackbar } from "notistack"
import i18n from "i18n"

// 1e-15: mismo suelo que el epsilon del checkbox-borrador en partida.js; por encima el PATCH es cantidad real y se limpia certDraftPartidaIds.
const CERT_CURRENT_DRAFT_EPS = 1e-15

const Budget2023State = props => {
  const { dispatchs, getExtraChapterById } = useExtrasAndContradictionsContext()
  const { enqueueSnackbar } = useSnackbar()

  const initialState = {
    budgetTree: new Chapter({
      capituloInfo: {
        chapterId: "root",
      },
      partidas: null,
      subcapitulos: null,
    }),
    dynamicElement: {
      modalIsOpen: false,
      setModalIsOpen: () => {},
      selected: null,
      setSelected: () => {},
      selected: null,
      setSelected: () => {},
      projectId: null,
      setProjectId: () => {},
    },
    marginModal: {
      open: false,
      onClose: () => {},
      projectId: null,
      generalExpenses: 0,
      indirectExpenses: 0,
      industrialProfit: 0,
      discount: 0,
      formula: "NOT_SET",
    },
    loading: true,
    loadingRecalc: false,
    updating: false,
    readyToClose: false,
    urlDownload: "",
    selectedBudget2: [],
    selectedPartGroup: [],
    errorAgrupar: false,
    changeSidebar: 0,
    selectedChaptersGroup: [],
    partsChecked: [],
    chaptersChecked: [],
    imChecked: { isChecked: false, partida: null },
    imChecked2: { isChecked: false, capitulo: null },
    tags: [],
    tagsFiltered: [],
    budgetPdf: null,
    loadingBudgetPdf: false,
    versionToDisplay: {},
    loadingAgruparChapters: false,
    loadingAgruparParts: false,
    sendChapters: [],
    loadingSend: false,
    sendOk: false,
    preferencias: {
      basededatos: false, //si hay margen global a true
      clientPrice: true,
      descuento: false, //si el discount es >0 true
      objetivo: true,
      procedencia: true,
      precioCoste: true,
    },
    copiedData: null,
    lastActions: [],
    isContradictingPart: false,
    modalBudgetingError: {
      isOpen: false,
      error: null,
      location: "",
    },
    loadingIcon: {
      isLoading: false,
      index: null,
    },
    isBudgetClosed: false,
    closeInfo: {
      clientPrice: null,
      reducedPrice: null,
    },
    certification: {
      generalUpdate: false,
      setGeneralUpdate: () => {},
      loading: false,
      chapterCertInProgress: false,
      setChapterCertInProgress: () => {},
      notifyChapterCertApiStarted: () => {},
      notifyChapterCertApiCompleted: () => {},
      getChapterCertApiPendingCount: () => 0,
      isChapterCertBatchActive: () => false,
    },
    certDraftPartidaIds: {},
    coefficients: {},
    budgetMode: "standard",
    baseCert: "client",
  }
  const location = useLocation()
  const isExtrasPath = location.pathname.includes("/extras")

  const APINAME = "dev-PLANHOPPER-API"
  const SERVICE_BUDGET = "service-budget"
  const SERVICE_BUDGET_TEMP = "service-budgeting-temp"
  const SERVICE_PART_CORE = "service-part-core"
  const SERVICE_CORE_BASE = "service-core-base"

  const [state, dispatch] = useReducer(Budget2023Reducer, initialState)
  const chapterCertApiPendingCountRef = useRef(0)
  /** True en el mismo tick que setChapterCertInProgress(true), antes del re-render (evita perder el primer update). */
  const chapterCertBatchActiveRef = useRef(false)

  const getCommonHeaders = async () => {
    const commonHeaders = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      },
    }
    return commonHeaders
  }

  async function deleteChapterRecursive(listaCapitulos, capitulo) {
    for (let i = 0; i < listaCapitulos.length; i++) {
      if (listaCapitulos[i].chapterId === capitulo.chapterId) {
        listaCapitulos.splice(i, 1)
        break
      } else {
        deleteChapterRecursive(listaCapitulos[i].subcapitulos, capitulo)
      }
    }
  }

  function getSelectedBudget(selectedBudget, capitulos) {
    for (let i = 0; i < capitulos.length; i++) {
      if (capitulos[i].checked) {
        selectedBudget.push({ ...capitulos[i] })

        if (capitulos[i].partidas.length > 0) {
          let copia = []
          for (let j = 0; j < capitulos[i].partidas.length; j++) {
            if (capitulos[i].partidas[j].checked == true) {
              copia.push(capitulos[i].partidas[j])
            }
          }
          selectedBudget[selectedBudget.length - 1].partidas = copia
        }
      }
      if (capitulos[i].subcapitulos.length > 0) {
        getSelectedBudget(selectedBudget, capitulos[i].subcapitulos)
      }
    }
    if (selectedBudget.length == 0) {
      selectedBudget = state.budgetTree.subcapitulos
    }
    dispatch({
      type: "SET_SELECTED",
      payload: {
        selectedBudget: selectedBudget,
      },
    })
  }

  function getSelectedChapters(selectedBudget, auxList, totalCaps, start) {
    for (let i = 0; i < totalCaps.length; i++) {
      if (totalCaps[i].checked) {
        if (totalCaps[i].subcapitulos.length > 0) {
          let auxChapter = { ...totalCaps[i] }
          auxChapter.subcapitulos = []
          auxList.push(auxChapter)
          getSelectedChapters(
            selectedBudget,
            auxList[auxList.length - 1].subcapitulos,
            totalCaps[i].subcapitulos,
            start,
          )
        } else if (totalCaps[i].partidas.length > 0) {
          let auxChapter = { ...totalCaps[i] }
          auxChapter.partidas = []
          let copia = []
          for (let j = 0; j < totalCaps[i].partidas.length; j++) {
            if (totalCaps[i].partidas[j].checked == true) {
              copia.push(totalCaps[i].partidas[j])
            }
          }
          auxChapter.partidas = copia
          auxList.push(auxChapter)
        }
      } else {
        if (totalCaps[i].subcapitulos.length > 0) {
          getSelectedChapters(
            selectedBudget,
            auxList,
            totalCaps[i].subcapitulos,
            start,
          )
        }
      }
    }
    if (auxList.length == 0) {
      auxList = state.budgetTree.subcapitulos
    }
    dispatch({
      type: "SET_SELECTED",
      payload: {
        selectedBudget: auxList,
      },
    })
  }

  function getSelectedBudget2(selectedBudget, capitulos) {
    for (let i = 0; i < capitulos.length; i++) {
      if (capitulos[i].checked) {
        selectedBudget.push({ ...capitulos[i].capituloInfo })
      }
      if (capitulos[i].subcapitulos.length > 0) {
        getSelectedBudget2(selectedBudget, capitulos[i].subcapitulos)
      }
    }
    dispatch({
      type: "SELECCIONAR_AGRUPAR",
      payload: {
        selectedBudget: selectedBudget,
      },
    })
  }

  function selectPartsGroup(selectedParts, capitulos) {
    for (let i = 0; i < capitulos.length; i++) {
      if (capitulos[i].checked) {
        dispatch({
          type: "ERROR_CAPITULO",
          payload: {
            error: true,
          },
        })
        return false
      } else {
        if (capitulos[i].partidas.length > 0) {
          let copia = []
          for (let j = 0; j < capitulos[i].partidas.length; j++) {
            if (capitulos[i].partidas[j].checked == true) {
              copia.push(capitulos[i].partidas[j])
            }
          }
          if (copia.length > 0) {
            if (!copia.isEmpty) {
              selectedParts.push(copia)
            }
          }
        }
        if (capitulos[i].subcapitulos.length > 0) {
          selectPartsGroup(selectedParts, capitulos[i].subcapitulos)
        }
      }
    }
    dispatch({
      type: "SET_GROUP",
      payload: {
        selectedParts: selectedParts,
        error: false,
      },
    })
  }

  const getBudgetTree = async (projectId, soyFinal) => {
    if (!projectId || projectId === "undefined") return
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      const legacyMeta = await API.get(
        "CORE",
        `/projects/legacy/full?projectId=${encodeURIComponent(projectId)}`,
        payload,
      )
      const downloadUrl = legacyMeta?.download_url
      if (!downloadUrl) {
        throw new Error("legacy full project: missing download_url")
      }

      const { data: respFullProject } = await axios.get(downloadUrl)
      if (respFullProject.coefficients) {
        Chapter.setCoefficients(respFullProject.coefficients)
        dispatch({
          type: "SET_COEFFICIENTS",
          payload: respFullProject.coefficients,
        })
      }

      const {
        price,
        priceReduced,
        finalPrice,
        finalPriceWithoutDiscount,
        is_closed,
        closeInfo: responseCloseInfo,
        costeGeneral,
        costeIndirecto,
        industrialProfit,
        discount,
        marginFormula,
        budgetMode,
        base_cert,
      } = respFullProject

      if (budgetMode) {
        dispatch({
          type: "SET_BUDGET_MODE",
          payload: budgetMode,
        })
      }

      setCloseInfo(responseCloseInfo)

      const baseCertValue = base_cert ? base_cert : "client"

      Chapter.setBaseCert(baseCertValue)

      dispatch({
        type: "SET_BASE_CERT",
        payload: baseCertValue,
      })

      const priceReducedValue = priceReduced ?? price

      const chapterRoot = new Chapter({
        capituloInfo: {
          chapterId: "root",
        },
        partidas: null,
        subcapitulos: null,
        price: price,
        priceReduced: priceReducedValue,
        clientPrice: finalPrice,
        clientPriceWithoutDiscount: finalPriceWithoutDiscount,
        totalDiscount: 0,
      })
      setIsBudgetClosed(is_closed)
      dispatch({
        type: "LOADING_BUDGET",
        payload: {
          loading: true,
          budgetTree: chapterRoot,
        },
      })

      dispatch({
        type: SET_MARGIN_MODAL_INITIAL_VALUE,
        payload: {
          margin: {
            generalExpenses: costeGeneral,
            indirectExpenses: costeIndirecto,
            industrialProfit: industrialProfit,
            discount: discount,
            formula: marginFormula,
          },
        },
      })

      let subcapitulosAux = respFullProject.chapters.map(chapter => {
        const { chapters, partidas, ...rest } = chapter
        const chapterFormatted = {
          ...rest,
          partidas: partidas.map(p => ({ partidaId: p })),
        }
        const oChapter = new Chapter({
          ...chapterFormatted,
          capituloInfo: chapterFormatted,
        })
        oChapter.fillAllFromRoot(chapter.chapterId, chapter.chapters)
        oChapter.updateCostReal()
        if (oChapter.partidas && oChapter.partidas.length === 0) {
          oChapter.totalCertPreviousChapter = oChapter.subcapitulos.reduce(
            (acc, cap) => acc + cap.totalCertPreviousChapter,
            0,
          )
          oChapter.totalCertCurrentChapter = oChapter.subcapitulos.reduce(
            (acc, cap) => acc + cap.totalCertCurrentChapter,
            0,
          )
        } else {
          oChapter.totalCertPreviousChapter =
            oChapter.calculatePreviousTotalChapter()
          oChapter.totalCertCurrentChapter =
            oChapter.calculateCurrentTotalChapter()
        }
        return oChapter
      })

      if (subcapitulosAux.length === 0) {
        const response = await API.get(
          SERVICE_BUDGET,
          `/project/${projectId}?parentId=root`,
          payload,
        )

        subcapitulosAux = response.chapters.map(
          capitulo => new Chapter({ ...capitulo, capituloInfo: capitulo }),
        )
      }

      dispatch({
        type: "SET_BUDGET_TREE",
        payload: subcapitulosAux,
      })

      dispatch({
        type: SET_FOOTER_VALUES,
      })
    } catch (e) {
      dispatch({
        type: "ERR_BUDGET_TREE",
        payload: { loading: false },
      })
    }
  }

  const getSubCapitulosContent = async (projectId, chapterId) => {
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      const response = await API.get(
        SERVICE_BUDGET,
        `/project/${projectId}?parentId=` + chapterId,
        payload,
      )
      dispatch({
        type: "FILL_CHAPTER_CONTENT",
        payload: {
          chapterId: chapterId,
          content: response,
        },
      })
    } catch (e) {
      dispatch({
        type: "ERR_BUDGET_TREE",
        payload: { loading: false },
      })
    }
  }

  const getSubCapitulosContent2 = async (projectId, chapterId) => {
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      const response = await API.get(
        SERVICE_BUDGET,
        `/project/${projectId}?parentId=` + chapterId,
        payload,
      )
      dispatch({
        type: "FILL_CHAPTER_CONTENT_2",
        payload: {
          chapterId: chapterId,
          content: response,
        },
      })
    } catch (e) {
      dispatch({
        type: "ERR_BUDGET_TREE",
        payload: { loading: false },
      })
    }
  }

  const updateCapitulov2 = async data => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })
      let headers = {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      }
      let body = { ...data, organizationId: data.capituloInfo.organizationId }
      const res = await API.put(
        SERVICE_BUDGET_TEMP,
        "/chapter/" + body.chapterId,
        { headers: headers, body: body },
      )
      dispatch({
        type: "UPDATE_CAPITULO",
        payload: {
          newData: res.chapter,
          capituloId: res.chapter.chapterId,
        },
      })
    } catch (e) {
      console.log(e)
    }
  }
  const updatePartidav2 = async (
    data,
    capituloId,
    accountId,
    soyManual,
    from,
  ) => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })

      dispatch({
        type: CERTIFICATION_LOADING,
        payload: true,
      })

      let headers = {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      }
      let auxDecomposition = data.decomposition
      if (data.decomposition.length > 0) {
        for (let i = 0; i < data.decomposition.length; i++) {
          auxDecomposition[i].price = parseFloat(
            auxDecomposition[i].price.toString().replace(",", "."),
          )
          auxDecomposition[i].quantity = parseFloat(
            auxDecomposition[i].quantity.toString().replace(",", "."),
          )
          auxDecomposition[i].type =
            auxDecomposition[i].type == "coste"
              ? 0
              : auxDecomposition[i].type == "manodeobra"
                ? 1
                : auxDecomposition[i].type == "maquinaria"
                  ? 2
                  : auxDecomposition[i].type == "residuoAdicional"
                    ? 4
                    : auxDecomposition[i].type == "residuoClasificacion"
                      ? 5
                      : auxDecomposition[i].type == "material"
                        ? 3
                        : 1
        }
      }
      let deleteMeasures = false
      if (data?.measures.length == 1) {
        if (
          data.measures[0].description == "" &&
          data.measures[0].quantity == 0 &&
          data.measures[0].total == 0 &&
          data.measures[0].height == 0 &&
          data.measures[0].depth == 0 &&
          data.measures[0].width == 0
        ) {
          deleteMeasures = true
        }
      }
      const newCostReal = !isNil(data.costReal)
        ? parseFloat(data.costReal)
        : null

      let body = {
        ...data,
        name: data.name,
        accountId: accountId,
        projectId: data.projectId,
        partidaId: data.partidaId,
        decomposition: auxDecomposition ? auxDecomposition : [],
        description: data.description ? data.description : data.resumen,
        quantity: data.quantity ? parseFloat(data.quantity) : 0,
        code: data.code,
        unity: data.unity ? data.unity : null,
        status: "OPEN",
        // data.margin could be 0, so we need to check if it is defined
        costReal: newCostReal,
        costeGeneral: data.hasOwnProperty("margin")
          ? parseFloat(data.margin)
          : data.costeGeneral
            ? parseFloat(data.costeGeneral)
            : 0,
        costeIndirecto: data.costeIndirecto
          ? parseFloat(data.costeIndirecto)
          : 0,
        industrialProfit: data.industrialProfit
          ? parseFloat(data.industrialProfit)
          : 0,
        measures: data.measures ? (deleteMeasures ? [] : data.measures) : [],
        soyManual: soyManual ? soyManual : 0,
        discount: data.discount ? data.discount : 0,
        comeFrom: data.comeFrom ? data.comeFrom : null,
        price: data.price ? parseFloat(data.price) : 0,
        priceReduced: data.priceReduced ? parseFloat(data.priceReduced) : 0,
        refPrice: data.refPrice ? parseFloat(data.refPrice) : 0,
        clientPrice: data.clientPrice ? parseFloat(data.clientPrice) : 0,
      }

      const res = await API.put(
        SERVICE_BUDGET_TEMP,
        "/part/" + data.partidaId,
        { headers: headers, body: body },
      )

      if (from === EXTRAS_AND_CONTRADICTIONS) {
        dispatchs.updatePart({ ...res, partId: res.partidaId }, capituloId)
      }

      const partidaUpdated2 = {
        partidaId: res,
        elementInfo: null,
      }

      dispatch({
        type: "UPDATE_PARTIDA",
        payload: {
          newData: partidaUpdated2,
          capituloId: capituloId,
          final: false,
        },
      })

      dispatch({
        type: CERTIFICATION_LOADING,
        payload: false,
      })
    } catch (e) {
      console.log(e)
      dispatch({
        type: CERTIFICATION_LOADING,
        payload: false,
      })
    }
  }

  const getCertAuthHeaders = async () => ({
    Authorization: `Bearer ${(await Auth.currentSession())
      .getIdToken()
      .getJwtToken()}`,
    "Access-Control-Allow-Origin": "*",
  })

  const findPartidaInBudgetTree = partidaId => {
    if (state.budgetTree && typeof state.budgetTree.preOrder === "function") {
      for (let chapter of state.budgetTree.preOrder()) {
        const partida = (chapter.partidas || []).find(
          part => part.partidaId === partidaId,
        )
        if (partida) return partida
      }
    }
    return null
  }

  const findCertPreviousForPartida = partidaId => {
    const partida = findPartidaInBudgetTree(partidaId)
    return partida ? Number(partida.cert_previous) || 0 : 0
  }

  const clearCertification = async partidaId => {
    dispatch({
      type: CERTIFICATION_LOADING,
      payload: true,
    })

    try {
      const headers = await getCertAuthHeaders()
      await API.del("CORE", "/cert/clear/" + partidaId, {
        headers,
      })

      const certPrevious = findCertPreviousForPartida(partidaId)
      const partidaInTree = findPartidaInBudgetTree(partidaId)
      const partidaUpdated = {
        cert_total: certPrevious,
        cert_current: 0,
        money_current: 0,
      }
      if (partidaInTree?.measures?.length) {
        partidaUpdated.measures = partidaInTree.measures.map(m => ({
          ...m,
          cert_current: 0,
        }))
      }

      dispatch({
        type: "PATCH_PARTIDA_BY_ID",
        payload: {
          partidaId,
          changes: partidaUpdated,
        },
      })

      dispatch({
        type: CERT_DRAFT_SET_PARTIDA,
        payload: { partidaId, included: false, draftMode: "total" },
      })

      dispatch({
        type: CERTIFICATION_LOADING,
        payload: false,
      })

      return partidaUpdated
    } catch (e) {
      dispatch({
        type: CERTIFICATION_LOADING,
        payload: false,
      })
      throw e
    }
  }

  const updateCertCurrent = async (partidaId, cert_current, measures) => {
    dispatch({
      type: CERTIFICATION_LOADING,
      payload: true,
    })

    try {
      const headers = await getCertAuthHeaders()

      let body = {}
      if (measures) {
        body = {
          measures: measures.map(m => m.cert_current),
        }
      } else {
        body = { cert_current }
      }

      const res = await API.patch("CORE", "/cert/" + partidaId, {
        headers: headers,
        body: body,
      })
      const partidaUpdated = res.parts[0]

      const changes = {
        cert_current,
      }
      if (measures) {
        changes.measures = measures
      }

      dispatch({
        type: "PATCH_PARTIDA_BY_ID",
        payload: {
          partidaId,
          changes: changes,
        },
      })

      if (measures) {
        const sumM = measures.reduce(
          (acc, m) => acc + (parseFloat(m.cert_current) || 0),
          0,
        )
        dispatch({
          type: CERT_DRAFT_SET_PARTIDA,
          payload: {
            partidaId,
            included: sumM <= CERT_CURRENT_DRAFT_EPS,
            draftMode: "measures",
          },
        })
      } else {
        const cc = parseFloat(cert_current)
        if (!Number.isNaN(cc)) {
          if (cc > CERT_CURRENT_DRAFT_EPS) {
            dispatch({
              type: CERT_DRAFT_SET_PARTIDA,
              payload: { partidaId, included: false },
            })
          } else {
            dispatch({
              type: CERT_DRAFT_SET_PARTIDA,
              payload: { partidaId, included: true, draftMode: "total" },
            })
          }
        }
      }

      dispatch({
        type: CERTIFICATION_LOADING,
        payload: false,
      })

      return partidaUpdated
    } catch (e) {
      dispatch({
        type: CERTIFICATION_LOADING,
        payload: false,
      })
      throw e
    }
  }

  const updatePreciosFinalesv2 = async (data, capituloId, estoyEnFinal) => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })
      let headers = {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      }
      let body = {}
      if (data.industrialProfit) {
        body = {
          name: data.name,
          projectId: data.projectId,
          partidaId: data.partidaId,
          description: data.description ? data.description : data.resumen,
          quantity: data.quantity
            ? Number(data.quantity)
            : Number(data.unidades),
          code: data.code,
          userPrice: data.userPrice ? data.userPrice : 0,
          unity: data.unity ? data.unity : null,
          costeIndirecto: data.costeIndirecto,
          industrialProfit: data.industrialProfit,
          costeGeneral: data.hasOwnProperty("margin")
            ? parseFloat(data.margin)
            : data.costeGeneral
              ? parseFloat(data.costeGeneral)
              : 0,
          costeFinal: parseFloat(data.costeFinal),
          status: "OPEN",
        }
      } else {
        body = {
          name: "",
          projectId: data.projectId,
          partidaId: data.partidaId,
          description: data.resumen,
          quantity: Number(data.unidades),
          code: data.code,
          userPrice: data.userPrice ? data.userPrice : 0,
          costeFinal: data.costeFinal,
          costeGeneral: data.hasOwnProperty("margin")
            ? parseFloat(data.margin)
            : data.costeGeneral
              ? parseFloat(data.costeGeneral)
              : 0,
          unity: data.unity ? data.unity : null,
          status: "OPEN",
        }
      }
      const res = await API.put(APINAME, "/api/budget/update/partida", {
        headers: headers,
        body: body,
      })
      const partidaUpdated = {
        partidaId: res.partida,
        elementInfo: res.elementInfo,
      }
      dispatch({
        type: "UPDATE_PARTIDA",
        payload: {
          newData: partidaUpdated,
          capituloId: capituloId,
          final: estoyEnFinal,
        },
      })
    } catch (e) {
      console.log(e)
    }
  }

  const deleteCapitulo = async (capituloId, projectId) => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })
      const payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      const res = await API.del(
        SERVICE_BUDGET_TEMP,
        "/chapter/" + capituloId + "?projectId=" + projectId,
        payload,
      )

      dispatch({
        type: "DEL_CAPITULO",
        payload: { capituloId: capituloId, totalDiscount: res.totalDiscount },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const deleteCapituloAndSetPosition = async (capituloId, projectId) => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })
      const payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      const res = await API.del(
        SERVICE_BUDGET_TEMP,
        "/chapter/" + capituloId + "?projectId=" + projectId,
        payload,
      )

      dispatch({
        type: DEL_CAPITULO_SET_POSITION,
        payload: { capituloId: capituloId, totalDiscount: res.totalDiscount },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const closeCertification = async projectId => {
    try {
      const payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }

      await axios.post(CORE_URL + "/cert/create/" + projectId, null, {
        headers: payload.headers,
      })

      return true
    } catch (error) {
      console.log(error)
      return false
    }
  }

  const addCapituloV2 = async (data, indexCapitulo) => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })

      let commonHeaders = getCommonHeaders()
      const payload2 = {
        ...commonHeaders,
        body: null,
      }
      const res = await API.post(
        SERVICE_CORE_BASE,
        data.chapterId
          ? `/chapters/create?projectId=${data.projectId}&parentId=${data.parentId}`
          : `/chapters/create?projectId=${data.projectId}`,
        payload2,
      )

      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: res.chapterId ? res.chapterId : "root",
          res: { ...res.chapters[0], capituloInfo: res.chapters[0] },
          indexCapitulo: res.chapters[0].position,
        },
      })

      if (data.partidas.length > 0) {
        dispatch({
          type: MOVE_PARTS_BY_CHAPTERS_ID,
          payload: {
            parentId: res.chapterId,
            chapterId: res.chapters[0],
          },
        })
      }
    } catch (error) {
      console.log(error)
    }
  }
  const deleteMultipleParts = async user => {
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      while (state.partsChecked.length > 0) {
        const res = await API.del(
          SERVICE_CORE_BASE,
          `/partida/?partidaId=${state.partsChecked[0].partidaId}`,
          payload,
        )
        dispatch({
          type: "DEL_PARTIDA",
          payload: {
            capituloId: state.partsChecked[0].chapterId,
            partidaId: state.partsChecked[0].partidaId,
            totalDiscount: res.totalDiscount,
          },
        })
        state.partsChecked.shift()
      }
      cleanParts()
    } catch (error) {
      console.log(error)
    }
  }
  const deletePartidav2 = async (capituloId, partidaId, accountId) => {
    dispatch({
      type: "ON_UPDATE",
    })
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }

      const res = await API.del(
        SERVICE_CORE_BASE,
        `/partida/?partidaId=${partidaId}`,
        payload,
      )
      dispatch({
        type: "DEL_PARTIDA",
        payload: {
          capituloId,
          partidaId,
          totalDiscount: res.totalDiscount,
        },
      })
      cleanParts()
      dispatch({
        type: "CLEAN_PARTS",
      })
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
    } catch (error) {
      console.log(error)
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
    }
  }
  const createPartidaV2 = async (
    accountId,
    chapterId,
    projectId,
    index,
    part,
    data,
    from,
  ) => {
    let chapter = null
    if (from == EXTRAS_AND_CONTRADICTIONS) {
      chapter = await getExtraChapterById(chapterId)
      chapter.partidas = chapter.parts
    } else {
      chapter = await getChapterById(chapterId, state.budgetTree.subcapitulos)
    }

    let indicePartida = 0
    if (chapter.capituloInfo) {
      if (chapter.partidas) {
        if (part) {
          indicePartida = await getPartIndex(chapter, part.partidaId)
          indicePartida = indicePartida + 1
        } else {
          indicePartida = 0
        }
      }
    }
    dispatch({
      type: "ON_UPDATE",
    })
    try {
      let auxRefPrice = 0
      if (data.refPrice) {
        auxRefPrice = parseFloat(data.refPrice)
      } else if (data.refPrice == 0) {
        auxRefPrice = 0
      } else if (data.price) {
        auxRefPrice = parseFloat(data.price)
      } else {
        auxRefPrice = 0
      }
      let auxDecomposition = data.decomposition

      if (data.decomposition.length > 0) {
        for (let i = 0; i < data.decomposition.length; i++) {
          auxDecomposition[i].price = parseFloat(
            String(auxDecomposition[i].price).replace(",", "."),
          )
          auxDecomposition[i].quantity = parseFloat(
            String(auxDecomposition[i].quantity).replace(",", "."),
          )
          auxDecomposition[i].type =
            auxDecomposition[i].type == "coste"
              ? 0
              : auxDecomposition[i].type == "manodeobra"
                ? 1
                : auxDecomposition[i].type == "maquinaria"
                  ? 2
                  : auxDecomposition[i].type == "residuoAdicional"
                    ? 4
                    : auxDecomposition[i].type == "residuoClasificacion"
                      ? 5
                      : auxDecomposition[i].type == "material"
                        ? 3
                        : 1
        }
      }
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          ...data,
          accountId: accountId,
          chapterId: chapterId,
          code: data ? (data.code ? data.code : null) : null,
          name: data ? data.name : "",
          description: data.resumen
            ? data.resumen
            : data.description
              ? data.description
              : "",
          quantity: data.quantity ? parseFloat(data.quantity) : 0,
          unity: data ? (data.unity ? data.unity : null) : null,
          price: data ? (data.price ? parseFloat(data.price) : 0) : 0,
          projectId:
            from !== EXTRAS_AND_CONTRADICTIONS ? chapter.projectId : projectId,
          status: "OPEN",
          position:
            index === "last" ? chapter?.partidas?.length : indicePartida,
          comeFrom: data ? data.comeFrom : null,
          refPrice: auxRefPrice,
          clientPrice: data.clientPrice,
          costeGeneral: data.hasOwnProperty("margin")
            ? parseFloat(data.margin)
            : data.costeGeneral
              ? parseFloat(data.costeGeneral)
              : 0,
          measures: data.measures,
          costeIndirecto: 0,
          industrialProfit: 0,
          decomposition: auxDecomposition ? auxDecomposition : [],
        },
      }
      const partida = await API.post(SERVICE_BUDGET_TEMP, "/part", payload)
      let aux = {
        partidaId: partida,
        elementInfo: null,
        chapterId: chapterId,
        creadaEnFinal: false,
      }
      let tmpIndex = chapter.partidas.length
      let partidaNueva = new Part(aux)
      dispatch({
        type: "ADD_PARTIDA",
        payload: {
          chapterId,
          partidaNueva,
          tmpIndex: tmpIndex + 1,
        },
      })

      if (from == EXTRAS_AND_CONTRADICTIONS) {
        //? agrega al árbol de extras y contradictions
        dispatchs.addPartToChapter(chapterId, partida)
      }
    } catch (error) {
      console.log(
        "%c❌ Error en createPartidaV2:",
        "color: red; font-weight: bold; font-size: 14px;",
        error,
      )
    }
  }
  const addImageToPart = async (
    accountId,
    partidaId,
    chapterId,
    projectId,
    file,
    extension,
    elementInfo,
  ) => {
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          chapterId: chapterId,
          partId: partidaId,
          accountId: accountId,
          projectId: projectId,
          filename: file.path,
          size: file.size,
          tags: ["foto"],
          extension: extension,
          contentType: file.type,
        },
      }
      const res = await API.post(APINAME, "/api/part/addImageToPart", payload)
      const partidaUpdated = {
        partidaId: res.partida,
        elementInfo: elementInfo,
      }
      const formData = new FormData()
      Object.keys(res.uploadInfo.fields).forEach(key => {
        formData.append(key, res.uploadInfo.fields[key])
      })
      formData.append("file", file)
      const res2 = await axios.post(res.uploadInfo.url, formData)
      dispatch({
        type: "ADD_IMAGE",
        payload: {
          newData: partidaUpdated,
          capituloId: chapterId,
          final: false,
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const deleteImageFromPart = async (
    accountId,
    partidaId,
    chapterId,
    fileId,
    elementInfo,
  ) => {
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          partId: partidaId,
          accountId: accountId,
          fileId: fileId,
        },
      }
      const res = await API.del(
        APINAME,
        "/api/part/removeImageFromPart",
        payload,
      )
      const partidaUpdated = {
        partidaId: res.partida,
        elementInfo: elementInfo,
      }
      dispatch({
        type: "ADD_IMAGE",
        payload: {
          newData: partidaUpdated,
          capituloId: chapterId,
          final: false,
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const updateIsExpanded = async capituloId => {
    dispatch({
      type: "UPDATE_IS_EXPANDED",
      payload: capituloId,
    })
  }

  const checkCapitulos = (capituloId, value) => {
    dispatch({
      type: "CHECK_CAPITULOS",
      payload: {
        capituloId,
        value,
      },
    })
  }

  const checkPartida = (capituloId, partidaId) => {
    dispatch({
      type: "CHECK_PARTIDA",
      payload: {
        capituloId,
        partidaId,
      },
    })
  }
  const uncheckAll = () => {
    dispatch({
      type: "UNCHECK_ALL",
    })
  }
  const closeBudget = () => {
    dispatch({
      type: "CLOSE_BUDGET",
    })
  }
  const isUpdates = () => {
    dispatch({
      type: "CHECK_UPDATES",
    })
  }
  const downloadBudget = async (
    projectId,
    name,
    typeDocument,
    typeBudget,
    options,
  ) => {
    try {
      let tipo = ""
      if (typeBudget == "PC") {
        tipo = "normal"
      } else {
        tipo = "final"
      }

      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      dispatch({
        type: "DOWNLOADING_BUDGET",
      })
      let route = ""
      let extension = ""
      let auxCaps = []
      for (let i = 0; i < state.chaptersChecked.length; i++) {
        auxCaps.push(state.chaptersChecked[i].chapterId)
      }
      if (typeDocument == "pdf") {
        route = "/project/download/" + projectId
        extension = ".pdf"
        let body = {
          chapters: auxCaps,
          typeDocument: "pdf",
          preview: false,
          briefing: options.briefing,
          options: { ...options, prices: options.price },
          objectivePrice: options.price,
          typeBudget: tipo == "normal" ? "cost" : "client",
        }
        const res = await API.post("service-budget", route, {
          headers: payload.headers,
          body: body,
        })

        axios({
          url: res.url,
          method: "GET",
          responseType: "blob",
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", name + extension) //or any other extension
          document.body.appendChild(link)
          link.click()
        })

        amplitude.track({
          event_type: "Budget PDF Downloaded",
          event_properties: { projectId: projectId, projectName: name },
        })
        dispatch({
          type: "DOWNLOAD_BUDGET",
        })
      } else if (typeDocument == "excel") {
        route = `/excel/s3/${projectId}`
        extension = ".xlsx"

        const params = {
          language: "es", // Intl, debería tomarlos del account
          currency: "EUR", //       para más adelante
          cost_price: options.cost, // Precio Coste Objetivo
          cost_real: false, // Precio Coste Real (No está el toggle)
          client_price: options.price, // Precio Cliente
          decomposition: options.decomposition, // Descomposición de partida
          decompositionFilter: options.decompositionFilter, // Descomposición de partida
          measures: options.measures, // Mediciones
          comment: options.comment, // Comentarios
          debug: false, // iddqd
        }

        const res = await API.post(SERVICE_CORE_BASE, route, {
          headers: payload.headers,
          body: params,
        })

        const link = document.createElement("a")
        link.href = res.url
        link.setAttribute("download", name + extension) //or any other extension
        document.body.appendChild(link)
        link.click()

        amplitude.track({
          event_type: "Budget Excel Downloaded",
          event_properties: { projectId: projectId, projectName: name },
        })
        dispatch({
          type: "DOWNLOAD_BUDGET",
        })
      }
    } catch (error) {
      return {
        error: true,
        message: String(error?.message ?? error),
        function: "/project/download/" + projectId,
        service: "service-budget",
      }
    }
  }

  const downloadCertification = async (
    projectId,
    name,
    options = {},
    certificationId = "",
  ) => {
    try {
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          language: "es",
          currency: "EUR",
          cost_price: false,
          cost_real: false,
          client_price: true,
          client_price_without_discount: false,
          cost_reduced: false,
          decomposition: options.decomposition ?? true,
          measures: options.measures ?? true,
          comment: options.comment ?? true,
          certifications: true,
          certification_id: certificationId,
          debug: false,
        },
      }

      dispatch({
        type: "DOWNLOADING_BUDGET",
      })
      const response = await API.post(
        SERVICE_CORE_BASE,
        `/excel/s3/${projectId}`,
        payload,
      )

      const link = document.createElement("a")
      link.href = response.url
      link.download = `${name.replace(" ", "_")}.xlsx`
      document.body.appendChild(link)
      link.click()
      amplitude.track({
        event_type: "Certification Excel Downloaded",
        event_properties: { projectId: projectId, projectName: name },
      })
      dispatch({
        type: "DOWNLOAD_BUDGET",
      })
    } catch (error) {
      return {
        error: true,
        message: String(error?.message ?? error),
        function: "/project/excel/cert_download/" + projectId,
        service: "service-budget",
      }
    }
  }

  const downloadCertificationAtOriginXls = async (
    projectId,
    name,
    certificationId,
  ) => {
    try {
      dispatch({
        type: "DOWNLOADING_BUDGET",
      })
      const request = {
        headers: await _headers(),
        body: {},
      }
      if (certificationId) {
        request.queryStringParameters = {
          certificationId,
        }
      }
      const blob = await API.post("CORE", `/docs/listo/cert/xls/${projectId}`, {
        ...request,
        responseType: "blob",
      })
      const objectUrl = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = objectUrl
      link.download = `${String(name).replace(/\s+/g, "_")}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(objectUrl)
      amplitude.track({
        event_type: "Certification At Origin Excel Downloaded",
        event_properties: {
          projectId,
          projectName: name,
          certificationId: certificationId || null,
        },
      })
      dispatch({
        type: "DOWNLOAD_BUDGET",
      })
    } catch (error) {
      dispatch({
        type: "DOWNLOAD_BUDGET",
      })
      return {
        error: true,
        message: String(error?.message ?? error),
        function: `/docs/listo/cert/xls/${projectId}`,
        service: "CORE",
      }
    }
  }

  const downloadCertificationAtOriginPdf = async (
    projectId,
    name,
    certificationId,
    { includeBudget = false } = {},
  ) => {
    try {
      dispatch({
        type: "DOWNLOADING_BUDGET",
      })
      const queryStringParameters = {
        include_budget: String(includeBudget),
      }
      if (certificationId) {
        queryStringParameters.certificationId = certificationId
      }
      const blob = await API.post("CORE", `/docs/listo/cert/pdf/${projectId}`, {
        headers: await _headers(),
        body: {},
        queryStringParameters,
        responseType: "blob",
      })
      const fileBlob =
        blob instanceof Blob
          ? blob
          : new Blob([blob], { type: "application/pdf" })
      const objectUrl = window.URL.createObjectURL(fileBlob)
      const link = document.createElement("a")
      link.href = objectUrl
      link.download = `${String(name).replace(/\s+/g, "_")}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(objectUrl)
      amplitude.track({
        event_type: "Certification At Origin PDF Downloaded",
        event_properties: {
          projectId,
          projectName: name,
          certificationId: certificationId || null,
          includeBudget,
        },
      })
      dispatch({
        type: "DOWNLOAD_BUDGET",
      })
    } catch (error) {
      dispatch({
        type: "DOWNLOAD_BUDGET",
      })
      return {
        error: true,
        message: String(error?.message ?? error),
        function: `/docs/listo/cert/pdf/${projectId}`,
        service: "CORE",
      }
    }
  }

  const _headers = async () => {
    let session
    try {
      session = await Auth.currentSession()
    } catch (e) {
      // Amplify v4 rejects with a bare string ("No current user") when the
      // local Cognito session is gone. Send the user to /login instead of
      // surfacing a generic error modal; the throw keeps callers' catch intact.
      localStorage.removeItem("userAuth")
      window.location.assign("/login")
      throw new Error(`Sesión expirada: ${e?.message ?? e}`)
    }
    return {
      Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      "Access-Control-Allow-Origin": "*",
    }
  }

  const pdfApi = async (projectId, options) => {
    try {
      const res = await API.post(
        "service-budget",
        `/project/pdf/generate/${projectId}`,
        {
          headers: await _headers(),
          body: { options: { ...options, prices: options.price } },
        },
      )
      return res
    } catch (error) {
      return {
        error: true,
        function: `/project/download/${projectId}`,
        message: String(error?.message ?? error),
        service: "service-budget",
      }
    }
  }

  const pdfCore = async (user, projectId, options) => {
    console.log("options", options)
    console.log("organizationId", user["custom:organizationId"])
    console.log("projectId", projectId)

    try {
      const res = await API.post("CORE", `/pdf/request`, {
        headers: _headers(),
        body: {
          projectId: projectId,
          organizationId: user["custom:organizationId"],
          options: {
            ...options,
            currency: user["custom:currency"],
            language: user["custom:idioma"],
          },
        },
      })
      return res
    } catch (error) {
      return {
        error: true,
        function: `/pdf/request`,
        message: String(error?.message ?? error),
        service: "service-budget",
      }
    }
  }

  const coreDownloadBC3 = async (projectId, options) => {
    try {
      const path = `/projects/${projectId}/S3/BC3`

      const queryStringParameters = {
        use_costs: options.addCosts,
        export_measurements: options.addMeasurements,
        export_decompositions: options.addDecompositions,
      }

      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
        queryStringParameters: queryStringParameters,
      }

      const res = await API.get(SERVICE_CORE_BASE, path, payload)

      const link = document.createElement("a")
      link.href = res.signed_url
      link.setAttribute("download", res.original_filename + res.extension)
      document.body.appendChild(link)
      link.click()

      return res
    } catch (error) {
      return {
        error: true,
        function: `/BC3/core`,
        message: String(error?.message ?? error),
        service: "service-budget",
      }
    }
  }

  const bc3Download = async (projectId, options) => {
    dispatch({
      type: "DOWNLOADING_BUDGET",
    })
    let res = null
    if (options.simpleMode === true) {
      res = await exportBudget2BC3(projectId, options.name)
    } else {
      res = await coreDownloadBC3(projectId, options)
    }
    dispatch({
      type: "DOWNLOAD_BUDGET",
    })
    return res
  }

  const pdfDownload = async (user, projectId, options) => {
    if (options.mode === "legacy") {
      return pdfApi(projectId, options)
    } else {
      return pdfCore(user, projectId, options)
    }
  }

  const pdfPreviewDownload = async (projectId, options) => {
    try {
      const res = await API.post("CORE", `/pdf/project/${projectId}`, {
        headers: _headers(),
        body: {
          options: options,
        },
        responseType: "blob",
      })
      return res
    } catch (error) {
      return {
        error: true,
        message: error,
      }
    }
  }

  const groupParts = async projectId => {
    dispatch({
      type: "GROUPING_PARTS",
    })
    let auxList = []
    let auxChapter = state.selectedPartGroup[0][0].chapterId
    let chapter = false
    let sameChapter = true
    for (let i = 0; i < state.selectedPartGroup.length; i++) {
      if (state.selectedPartGroup[i]) {
        if (state.selectedPartGroup[i].length > 0) {
          for (let j = 0; j < state.selectedPartGroup[i].length; j++) {
            if (state.selectedPartGroup[i][j].chapterId != auxChapter) {
              chapter = true
              sameChapter = false
            }
            auxList.push(state.selectedPartGroup[i][j])
          }
        }
      }
    }
    if (chapter == true) {
      auxChapter = "root"
    }
    let position = 0
    if (auxChapter === "root") {
      position = state.budgetTree.subcapitulos.length
    } else {
      let ch_tmp = state.budgetTree.getChapterById(auxChapter)
      position = ch_tmp.subcapitulos.length
    }

    let payload = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      },
      body: {
        projectId: projectId,
        chapterParentId: auxChapter,
        parts: auxList,
        sameChapter: sameChapter,
        position: position,
      },
    }
    const res = await API.post("service-budget", "/group-parts", payload)
    cleanParts()
    //getBudgetTree(projectId, false)
    dispatch({
      type: "POST_GROUP_PARTS",
      payload: {
        parts: res.parts,
        chapter: res.chapter,
        oldParts: auxList,
      },
    })
  }

  const groupChapters = async projectId => {
    dispatch({
      type: "GROUPING_CHAPTERS",
    })
    let chaptersToGroup = state.budgetTree.getChaptersToGroup()
    let chapterParentId = chaptersToGroup[0].parentId
    let same = true
    let counter = 1
    while (same === true && counter < chaptersToGroup.length) {
      if (chaptersToGroup[counter].parentId === chapterParentId) {
        counter++
      } else {
        same = false
        chapterParentId = "root"
      }
    }

    let payload = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      },
      body: {
        projectId: projectId,
        chapterParentId: chapterParentId,
        chapters: chaptersToGroup,
      },
    }

    const res = await API.post("service-budget", "/group-chapters", payload)

    let aux = []
    for (let index = 0; index < chaptersToGroup.length; index++) {
      aux.push(
        await getChapterById(
          chaptersToGroup[index].chapterId,
          state.budgetTree.subcapitulos,
        ),
      )
    }

    cleanChapters()
    dispatch({
      type: "POST_GROUP_CHAPTERS",
      payload: {
        chapterCreated: res.chapterCreated,
        newChapters: res.chapters,
        oldChapters: aux,
      },
    })
  }

  const detectChange = () => {
    dispatch({
      type: "CHANGE_DIMENSIONS",
      payload: {
        num: state.changeSidebar,
      },
    })
  }

  const updatePartsList = partida => {
    let find = false
    let i = 0
    while (!find && i < state.partsChecked.length) {
      if (state.partsChecked[i].partidaId == partida.partidaId) {
        state.partsChecked.splice(i, 1)
        find = true
      } else {
        i++
      }
    }
    if (find == false) {
      state.partsChecked.push(partida)
    }

    dispatch({
      type: "UPDATE_PARTS_LIST",
      payload: {
        list: state.partsChecked,
      },
    })
  }

  const updateChaptersList = chapter => {
    let find = false
    let i = 0
    while (!find && i < state.chaptersChecked.length) {
      if (state.chaptersChecked[i].chapterId == chapter.chapterId) {
        state.chaptersChecked.splice(i, 1)
        find = true
      } else {
        i++
      }
    }
    if (find == false) {
      state.chaptersChecked.push(chapter)
    }
    dispatch({
      type: "UPDATE_CHAPTERS_LIST",
      payload: {
        list: state.chaptersChecked,
      },
    })

    dispatch({
      type: "UPDATE_PARTS_LIST",
      payload: {
        list: [],
      },
    })
  }

  const changeCheck = objeto => {
    dispatch({
      type: "CHANGE_MOVING",
      payload: {
        res: objeto,
      },
    })
  }

  const changeCheck2 = objeto => {
    dispatch({
      type: "CHANGE_MOVING_2",
      payload: {
        res: objeto,
      },
    })
  }

  const moveChapters = async (projectId, chapterId, position, imChecked2) => {
    let pos = position
    let sameChapter = true
    let parent
    let copiaSubCapitulos = state.budgetTree.subcapitulos
    if (state.imChecked2.isChecked == false) {
      if (state.imChecked2.capitulo.chapterId != chapterId) {
        sameChapter = false
      }
      dispatch({
        type: "DEL_CAPITULO",
        payload: state.imChecked2.capitulo.chapterId,
      })

      parent = await getChapterParentId(chapterId, copiaSubCapitulos)

      let aux = {
        chapter: {
          ...state.imChecked2.capitulo.capituloInfo,
          parentId: parent,
        },
      }
      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: parent,
          res: aux,
          indexCapitulo: pos,
        },
      })
    } else {
      for (let i = 0; i < state.chaptersChecked.length; i++) {
        if (state.chaptersChecked[i].chapterId != chapterId) {
          sameChapter = false
        }
        dispatch({
          type: "DEL_CAPITULO",
          payload: state.chaptersChecked[i].chapterId,
        })
        state.chaptersChecked[i].checked = false
        parent = await getChapterParentId(chapterId, copiaSubCapitulos)
        let aux = { chapter: { ...state.chaptersChecked[i], parentId: parent } }
        dispatch({
          type: "ADD_CAPITULO",
          payload: {
            parentId: parent,
            res: aux,
            indexCapitulo: pos,
          },
        })

        pos = pos + 1
      }
    }
    dispatch({
      type: "CLEAN_STATE_FOR_MOVING_CHAPTERS",
      payload: {
        objeto: { isChecked: false, capitulo: null },
      },
    })

    //reorderParts(projectId, chapterId, state.imChecked2.isChecked==false? [state.imChecked2.partida] : state.partsChecked, position, sameChapter)
  }

  const checkMultipleChapters = async chapterId => {
    let parent = await getChapterParentId(
      chapterId,
      state.budgetTree.subcapitulos,
    )
    let chapter = {}
    if (parent != "root") {
      chapter = await getChapterById(parent, state.budgetTree.subcapitulos)
    } else {
      chapter = state.budgetTree
    }

    if (chapter.subcapitulos.length > 0) {
      let indiceChapter = await getChapterIndex(chapter, chapterId)
      let i = 0
      let trobat1 = false
      let trobat2 = false
      while ((!trobat1 || !trobat2) && i < chapter.subcapitulos.length) {
        if (chapter.subcapitulos[i].chapterId != chapterId) {
          if (chapter.subcapitulos[i].checked == true) {
            if (i < indiceChapter) {
              for (let j = i + 1; j < indiceChapter + 1; j++) {
                dispatch({
                  type: "CHECK_CAPITULOS",
                  payload: {
                    capituloId: chapter.subcapitulos[j].chapterId,
                    value: true,
                  },
                })
                state.chaptersChecked.push(chapter.subcapitulos[j].capituloInfo)
                dispatch({
                  type: "UPDATE_CHAPTERS_LIST",
                  payload: {
                    list: state.chaptersChecked,
                  },
                })
              }
              trobat1 = true
              i = indiceChapter
            } else {
              let valorIni = indiceChapter
              for (let j = indiceChapter; j < i; j++) {
                if (j == valorIni) {
                  if (chapter.subcapitulos[valorIni].checked == false) {
                    dispatch({
                      type: "CHECK_CAPITULOS",
                      payload: {
                        capituloId: chapter.subcapitulos[j].chapterId,
                        value: true,
                      },
                    })
                    state.chaptersChecked.push(chapter.subcapitulos[j])
                  }
                } else {
                  dispatch({
                    type: "CHECK_CAPITULOS",
                    payload: {
                      capituloId: chapter.subcapitulos[j].chapterId,
                      value: true,
                    },
                  })
                  state.chaptersChecked.push(chapter.subcapitulos[j])
                }
              }
              trobat2 = true
              i++
            }
          } else {
            i++
          }
        } else {
          i++
        }
      }
    }
  }

  const checkMultipleParts = async (chapterId, part) => {
    let chapter = await getChapterById(chapterId, state.budgetTree.subcapitulos)
    if (chapter.partidas.length > 0) {
      //busqueda para el indice de la partida
      let indicePartida = await getPartIndex(chapter, part.partidaId)
      //busqueda para ver que partidas se han checkeado antes de (part)
      let i = 0
      let trobat1 = false
      let trobat2 = false
      while ((!trobat1 || !trobat2) && i < chapter.partidas.length) {
        if (chapter.partidas[i].partidaId != part.partidaId) {
          if (chapter.partidas[i].checked == true) {
            if (i < indicePartida) {
              for (let j = i + 1; j < indicePartida + 1; j++) {
                dispatch({
                  type: "CHECK_PARTIDA",
                  payload: {
                    capituloId: chapterId,
                    partidaId: chapter.partidas[j].partidaId,
                  },
                })
                state.partsChecked.push(chapter.partidas[j])
                dispatch({
                  type: "UPDATE_PARTS_LIST",
                  payload: {
                    list: state.partsChecked,
                  },
                })
              }
              trobat1 = true
              i = indicePartida
            } else {
              let valorIni = indicePartida
              for (let j = indicePartida; j < i; j++) {
                if (j == valorIni) {
                  if (chapter.partidas[valorIni].checked == false) {
                    dispatch({
                      type: "CHECK_PARTIDA",
                      payload: {
                        capituloId: chapterId,
                        partidaId: chapter.partidas[j].partidaId,
                      },
                    })
                    state.partsChecked.push(chapter.partidas[j])
                    dispatch({
                      type: "UPDATE_PARTS_LIST",
                      payload: {
                        list: state.partsChecked,
                      },
                    })
                  }
                } else {
                  dispatch({
                    type: "CHECK_PARTIDA",
                    payload: {
                      capituloId: chapterId,
                      partidaId: chapter.partidas[j].partidaId,
                    },
                  })
                  state.partsChecked.push(chapter.partidas[j])
                  dispatch({
                    type: "UPDATE_PARTS_LIST",
                    payload: {
                      list: state.partsChecked,
                    },
                  })
                }
              }
              trobat2 = true
              i++
            }
          } else {
            i++
          }
        } else {
          //esquivo la partida ya marcada y paso a la siguiente
          i++
        }
      }
    }
  }

  const addToSelfManagement = async (projectId, chapterId) => {
    let payload = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      },
      body: {
        projectId: projectId,
        chapterId: chapterId,
      },
    }
    const res = await API.put("service-budget", "/addToSelfManagement", payload)
    getBudgetTree(projectId, false)
  }

  const reorderPartWithinChapter = async ({ partidaId, newPosition } = {}) => {
    if (state.isBudgetClosed || !partidaId || newPosition == null) {
      return false
    }

    const part = findPartidaInBudgetTree(partidaId)
    if (!part?.chapterId) {
      return false
    }

    const chapter = state.budgetTree.getChapterById(part.chapterId)

    if (!chapter?.partidas?.length) {
      return false
    }

    const sourceIndex = chapter.partidas.findIndex(
      currentPart => currentPart.partidaId === partidaId,
    )

    if (sourceIndex === -1) {
      return false
    }

    const numericNewPosition = Number(newPosition)

    if (Number.isNaN(numericNewPosition)) {
      return false
    }

    const normalizedNewPosition = Math.max(
      0,
      Math.min(numericNewPosition, chapter.partidas.length - 1),
    )

    if (sourceIndex === normalizedNewPosition) {
      return false
    }

    dispatch({
      type: "REORDER_PARTIDA_WITHIN_CHAPTER",
      payload: {
        chapterId: part.chapterId,
        partidaId,
        targetIndex: normalizedNewPosition,
      },
    })

    try {
      const headers = await getCommonHeaders()
      const reorderResponse = await API.post(
        "CORE",
        `/partida/reorder/${partidaId}/${normalizedNewPosition}`,
        headers,
      )
      if (reorderResponse?.error) {
        throw new Error("Error al reordenar la partida")
      }
      return true
    } catch (error) {
      dispatch({
        type: "REORDER_PARTIDA_WITHIN_CHAPTER",
        payload: {
          chapterId: part.chapterId,
          partidaId,
          targetIndex: sourceIndex,
        },
      })
      enqueueSnackbar(i18n.t("snackbar.error.reorderPartida"), {
        variant: "error",
      })
      return false
    }
  }

  const getTagsByProject = async () => {
    let auxTags = []
    for (let i = 0; i < state.budgetTree.subcapitulos.length; i++) {
      if (state.budgetTree.subcapitulos[i].capituloInfo.tags != undefined) {
        if (state.budgetTree.subcapitulos[i].capituloInfo.tags.length > 0) {
          for (
            let j = 0;
            j < state.budgetTree.subcapitulos[i].capituloInfo.tags.length;
            j++
          ) {
            auxTags.push(state.budgetTree.subcapitulos[i].capituloInfo.tags[j])
          }
        }
      }
    }

    dispatch({
      type: "UPDATE_TAGS_LIST",
      payload: {
        tagsList: auxTags,
      },
    })
  }

  const saveTagsToFilter = async tagsFiltered => {
    dispatch({
      type: "SAVE_TAGS_LIST",
      payload: {
        tagsList: tagsFiltered,
      },
    })
  }

  const closeEntireBudget = async data => {
    let payload = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      },
      body: data,
    }
    const res = await API.put("service-budget", "/closeEntireBudget", payload)
  }

  const changeVersion = async version => {
    dispatch({
      type: "CHANGE_VERSION",
      payload: {
        version: version,
      },
    })
  }

  const getVersionTree = async (version, projectId, soyFinal) => {
    try {
      dispatch({
        type: "LOADING_BUDGET",
        payload: {
          loading: true,
          budgetTree: new Chapter({
            capituloInfo: {
              chapterId: "root",
            },
            partidas: null,
            subcapitulos: null,
          }),
        },
      })

      if (soyFinal == true) {
        let response1 = await fetch(
          "https://cdn.tribboo.co/" + version.keyFinal,
        )
        let response = await response1.json()
        let subcapitulosAux = []
        for (let i = 0; i < response.length; i++) {
          let aux = new Chapter(response[i])
          subcapitulosAux.push(aux)
        }
        dispatch({
          type: "SET_BUDGET_TREE",
          payload: subcapitulosAux,
        })
      } else {
        let response1 = await fetch(
          "https://cdn.tribboo.co/" + version.keyNormal,
        )
        let response = await response1.json()
        let subcapitulosAux = []
        for (let capitulo of response) {
          let aux = new Chapter(capitulo)
          subcapitulosAux.push(aux)
        }
        dispatch({
          type: "SET_BUDGET_TREE",
          payload: subcapitulosAux,
        })
      }
    } catch (e) {
      dispatch({
        type: "ERR_BUDGET_TREE",
        payload: { loading: false },
      })
    }
  }

  const cleanParts = async () => {
    dispatch({
      type: "UPDATE_PARTS_LIST",
      payload: {
        list: [],
      },
    })
  }

  const cleanChapters = async () => {
    dispatch({
      type: "UPDATE_CHAPTERS_LIST",
      payload: {
        list: [],
      },
    })
  }

  const ExportToBankPrices = async (chapterDestination, parts, chapters) => {
    let partsIds = []
    let chaptersIds = []

    parts.map(part => {
      partsIds.push(part.partidaId)
    })

    chapters.map(chapter => {
      chaptersIds.push(chapter.chapterId)
    })

    let headers = {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
      "Access-Control-Allow-Origin": "*",
    }
    let body = {
      chapterDestination: chapterDestination.chapterId,
      chapterIds: chaptersIds,
      partIds: partsIds,
    }

    const res = await API.post("service-budget", "/export/bank-prices", {
      headers: headers,
      body: body,
    })
  }

  const createPartsOnBudget = async (
    accountId,
    parts,
    projectInfo,
    chapterId,
    capituloEntero,
    comeFrom,
    from,
  ) => {
    try {
      const safeParts = Array.isArray(parts) ? parts : []
      const isExtrasTarget =
        from == EXTRAS_AND_CONTRADICTIONS && chapterId !== "root"
      let chapterPartsLength = Array.isArray(capituloEntero?.partidas)
        ? capituloEntero.partidas.length
        : 0

      if (isExtrasTarget) {
        const extraChapter = await getExtraChapterById(chapterId).catch(
          () => null,
        )
        chapterPartsLength = Array.isArray(extraChapter?.parts)
          ? extraChapter.parts.length
          : chapterPartsLength
      }

      let auxChapterId
      if (chapterId == "root") {
        const path = "/chapter"
        let payload = {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            "Access-Control-Allow-Origin": "*",
          },
          body: {
            name: "PARTIDAS SIN CLASIFICAR",
            description: "",
            parentId: chapterId,
            projectId: projectInfo.projectId,
            price: 0,
            tags: [],
            status: "OPEN",
            position: 0,
            accountId: accountId,
          },
        }
        const res = await API.post(SERVICE_BUDGET_TEMP, path, payload)
        auxChapterId = res.chapterId
      } else {
        auxChapterId = chapterId
      }
      for (let i = 0; i < safeParts.length; i++) {
        let decomposition = []
        if (safeParts[i].desglose) {
          Object.keys(safeParts[i].desglose).forEach(key => {
            decomposition.push({
              description: safeParts[i].desglose[key]["RESUMEN"],
              quantity: parseFloat(
                parseFloat(safeParts[i].desglose[key]["RENDIMIENTO"]).toFixed(
                  2,
                ),
              ),
              price: parseFloat(
                parseFloat(safeParts[i].desglose[key]["PRECIO"]["E"]).toFixed(
                  2,
                ),
              ),
              type: parseInt(safeParts[i].desglose[key]["TIPO"]),
              unity: safeParts[i].desglose[key]["UNIDAD"],
            })
          })
        } else if (safeParts[i].decomposition) {
          safeParts[i].decomposition.forEach(item => decomposition.push(item))
        }
        let payload = {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            "Access-Control-Allow-Origin": "*",
          },
          body: {
            chapterId: auxChapterId,
            code: safeParts[i].code,
            name: safeParts[i].name,
            description: safeParts[i].description,
            quantity: 0,
            unity: safeParts[i].unity ? safeParts[i].unity : "pa",
            userPrice: safeParts[i].userPrice
              ? parseFloat(safeParts[i].userPrice)
              : parseFloat(safeParts[i].price),
            price: parseFloat(
              safeParts[i].userPrice
                ? safeParts[i].userPrice
                : safeParts[i].price,
            ),
            costeGeneral: projectInfo.costeGeneral,
            costeIndirecto: projectInfo.costeIndirecto,
            industrialProfit: projectInfo.industrialProfit,
            projectId: projectInfo.projectId,
            status: "OPEN",
            position: chapterId == "root" ? i : chapterPartsLength + i,
            elementInfo: safeParts[i].elementInfo
              ? safeParts[i].elementInfo
              : null,
            comeFrom: comeFrom,
            accountId: accountId,
            decomposition: decomposition,
            refPrice: parseFloat(safeParts[i].price),
            clientPrice: 0,
          },
        }
        const partida = await API.post(SERVICE_BUDGET_TEMP, "/part", payload)

        let aux = {
          partidaId: partida,
          elementInfo: partida.elementInfo ? partida.elementInfo : null,
          chapterId: chapterId,
        }

        let tmpIndex = partida.position
        let partidaNueva = new Part(aux)

        if (isExtrasTarget) {
          dispatchs.addPartToChapter(chapterId, partida)
        } else {
          dispatch({
            type: "ADD_PARTIDA",
            payload: {
              chapterId,
              partidaNueva,
              tmpIndex: tmpIndex + 1,
            },
          })
        }
      }
    } catch (e) {
      console.log(e)
      throw e
    }
  }

  const exportBudget2BC3 = async (projectId, name) => {
    let payload = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      },
    }
    const res = await API.post(
      "service-budget",
      "/project/export/bc3/" + projectId,
      payload,
    )
    const extension = ".bc3"
    axios({
      url: res,
      method: "GET",
      responseType: "blob",
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", name + extension) //or any other extension
      document.body.appendChild(link)
      link.click()
    })
  }

  const getBudgetPDF = async projectId => {
    try {
      dispatch({
        type: "LOADING_BUDGET_PDF",
      })
      let auxCaps = []
      for (let i = 0; i < state.chaptersChecked.length; i++) {
        auxCaps.push(state.chaptersChecked[i].chapterId)
      }
      let route = "/project/download/" + projectId
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      let body = {
        chapters: auxCaps,
        typeDocument: "pdf",
        preview: true,
        objectivePrice: true,
        typeBudget: "cost",
        options: {
          price: true,
          client: false,
          company: true,
          description: true,
          cover: true,
        },
      }
      const res = await API.post("service-budget", route, {
        headers: payload.headers,
        body: body,
      })

      dispatch({
        type: "SET_BUDGET_PDF",
        payload: res.url,
      })
      return res
    } catch (e) {
      console.log(e)
    }
  }
  const updateFinalPrice = price => {
    dispatch({
      type: "UPDATE_FINALPRICE",
      payload: price,
    })
  }

  const recalcBudget = async projectId => {
    try {
      dispatch({
        type: "ON_UPDATE_RECALC",
      })
      const payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      console.log("🚀 ~ recalcBudget ~ payload:", payload)

      //await API.put(SERVICE_BUDGET, '/recalculate/cost/'+projectId, payload)
      //await API.put(SERVICE_BUDGET, '/recalculate/client/'+projectId, payload)
      await API.put(
        SERVICE_CORE_BASE,
        `/projects/${projectId}/recalculate`,
        payload,
      )
      dispatch({
        type: "RECALC_DONE",
      })
    } catch (error) {
      console.log(error)
    }
  }

  const moveChaptersWithArrows = async (projectId, chapter, movement) => {
    const chapterToMove = chapter
    var chapterToChange = {}
    if (movement == "up") {
      chapterToChange = await getChapterByParentAndPosition(
        chapterToMove.parentId,
        state.budgetTree.subcapitulos,
        chapterToMove.capituloInfo.position - 1,
        false,
        0,
        {},
      )
      dispatch({
        type: "DEL_CAPITULO",
        payload: { capituloId: chapterToChange.chapterId },
      })
      dispatch({
        type: "DEL_CAPITULO",
        payload: { capituloId: chapterToMove.chapterId },
      })
      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: chapterToMove.parentId,
          res: {
            ...chapterToMove,
            capituloInfo: chapterToMove,
            position: chapterToChange.capituloInfo.position,
          },
          indexCapitulo: chapterToChange.capituloInfo.position,
        },
      })
      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: chapterToChange.parentId,
          res: {
            ...chapterToChange,
            capituloInfo: chapterToChange,
            position: chapterToMove.capituloInfo.position,
          },
          indexCapitulo: chapterToMove.capituloInfo.position,
        },
      })
    } else {
      chapterToChange = await getChapterByParentAndPosition(
        chapterToMove.parentId,
        state.budgetTree.subcapitulos,
        chapterToMove.capituloInfo.position + 1,
        false,
        0,
        {},
      )
      dispatch({
        type: "DEL_CAPITULO",
        payload: { capituloId: chapterToChange.chapterId },
      })
      dispatch({
        type: "DEL_CAPITULO",
        payload: { capituloId: chapterToMove.chapterId },
      })
      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: chapterToChange.parentId,
          res: {
            ...chapterToChange,
            capituloInfo: chapterToChange,
            position: chapterToMove.capituloInfo.position,
          },
          indexCapitulo: chapterToMove.capituloInfo.position,
        },
      })
      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: chapterToMove.parentId,
          res: {
            ...chapterToMove,
            capituloInfo: chapterToMove,
            position: chapterToChange.capituloInfo.position,
          },
          indexCapitulo: chapterToChange.capituloInfo.position,
        },
      })
    }
    try {
      const position = movement === "down" ? 1 : -1
      let payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          chapterId: chapterToMove.chapterId,
          position: position,
        },
      }
      await API.patch(SERVICE_BUDGET, "/chapter/position", payload)
    } catch (error) {
      console.log(error)
    }
  }

  const exportToTemplate = async (
    chapterDestination,
    chapters,
    parts,
    templateId,
  ) => {
    let partsIds = []
    let chaptersIds = []

    parts.map(part => {
      partsIds.push(part.partidaId)
    })

    chapters.map(chapter => {
      chaptersIds.push(chapter.chapterId)
    })

    let headers = {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
      "Access-Control-Allow-Origin": "*",
    }
    let body = {
      chapterDestination: chapterDestination.chapterId
        ? chapterDestination.chapterId
        : "root",
      chapterIds: chaptersIds,
      partIds: partsIds,
      templateDestination: templateId,
    }

    const res = await API.post("service-budget", "/export/template", {
      headers: headers,
      body: body,
    })
  }

  const sendBudget = async ({
    message,
    contact,
    projectId,
    budgetTree,
    tipo,
    mediciones,
    precioObjetivo,
    options,
  }) => {
    //adaptar llamada para options
    try {
      dispatch({
        type: SENDING_MESSAGE,
        payload: message,
      })

      const payload = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
      const template = await API.get(
        "service-budget",
        "/documentTemplates/default-budget-pdf",
        payload,
      )

      if (Object.keys(template).length === 0) {
        const body = {
          Message: message,
          toAddress: contact.email,
          name: contact.completeName,
          contactInfo: contact,
          projectId: projectId,
          budgetTree: budgetTree,
          mediciones: mediciones,
          hasExcel:
            tipo.length == 1 ? (tipo[0] === "excel" ? true : false) : true,
          hasPdf: tipo.length == 1 ? (tipo[0] === "PDF" ? true : false) : true,
          precioObjetivo: precioObjetivo,
          Budget: {
            capitulos: state.sendChapters.map(capitulo => {
              return {
                nombreCapitulo: capitulo.nombreCapitulo,
                partidas: capitulo.partidas.map(partida => {
                  return {
                    codigo: partida.codigo,
                    cantidad: partida.cantidad,
                    precioUsuario: partida.precioUsuario,
                  }
                }),
              }
            }),
          },
        }
        const headers = {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        }
        let res

        res = await API.post("service-budget", "/sendBudgetExcelAndPdf", {
          headers: headers,
          body: body,
        })
        dispatch({
          type: SEND_COMPLETE,
          payload: message,
        })

        return res
      } else {
        const body = {
          Message: message,
          toAddress: contact.email,
          name: contact.completeName,
          contactInfo: contact,
          projectId: projectId,
          budgetTree: budgetTree,
          mediciones: mediciones,
          precioObjetivo: precioObjetivo,
          template: template.documentTemplateId,
          hasExcel:
            tipo.length == 1 ? (tipo[0] === "excel" ? true : false) : true,
          hasPdf: tipo.length == 1 ? (tipo[0] === "PDF" ? true : false) : true,
          Budget: {
            capitulos: state.sendChapters.map(capitulo => {
              return {
                nombreCapitulo: capitulo.nombreCapitulo,
                partidas: capitulo.partidas.map(partida => {
                  return {
                    codigo: partida.codigo,
                    cantidad: partida.cantidad,
                    precioUsuario: partida.precioUsuario,
                  }
                }),
              }
            }),
          },
        }
        const headers = {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          "Access-Control-Allow-Origin": "*",
        }
        let res

        res = await API.post("service-budget", "/sendBudgetExcelAndPdf", {
          headers: headers,
          body: body,
        })

        dispatch({
          type: SEND_COMPLETE,
          payload: message,
        })

        return res
      }
    } catch (e) {
      return {
        error: true,
        message: e?.message,
        function: "/sendBudgetExcelAndPdf",
        service: "service-budget",
      }
    }
  }

  const reset = () => {
    dispatch({
      type: RESET_SEND,
    })
  }

  const copyBudgetData = data => {
    dispatch({
      type: "COPY_DATA",
      payload: data,
    })
  }

  const undoAction = async () => {
    //la accion se guarda directamente como la inversa
    //ejemplo al crear un capitulo se guardara la accion como eliminar capitulo
    //en esta funcion solo hay que realizar la accion y actualizar la pila
    console.log("eeeee", state.lastActions[state.lastActions.length - 1])
    if (
      state.lastActions[state.lastActions.length - 1].action == "DELETE_CHAPTER"
    ) {
      let capituloId =
        state.lastActions[state.lastActions.length - 1].payload.capituloId
      let projectId =
        state.lastActions[state.lastActions.length - 1].payload.projectId
      await deleteCapitulo(capituloId, projectId)
      dispatch({
        type: "REMOVE_LAST_UNDO_ACTION",
      })
    }
  }
  const deletePartDecomposition = async (partida, recoverBool) => {
    try {
      dispatch({
        type: "ON_UPDATE",
      })
      let headers = {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        "Access-Control-Allow-Origin": "*",
      }
      const res = await API.post(
        SERVICE_BUDGET,
        "/part/setDecomposition/" + partida.partidaId,
        { headers: headers, body: { decomposition: recoverBool } },
      )
      const partidaUpdated2 = {
        partidaId: res.partida,
        elementInfo: null,
      }
      console.log(partidaUpdated2)
      dispatch({
        type: "UPDATE_PARTIDA",
        payload: {
          newData: partidaUpdated2,
          capituloId: partidaUpdated2.partidaId.chapterId,
          final: false,
        },
      })
    } catch (e) {
      console.log(e)
    }
  }

  const setIsContradictingPart = isEditing => {
    dispatch({
      type: IS_CONTRADICTING_PART,
      payload: isEditing,
    })
  }

  const setModalBudgetingError = data => {
    dispatch({
      type: SET_MODAL_BUDGETING_ERROR,
      payload: data,
    })
  }

  const groupByChapterId = parts => {
    const groups = {}
    parts.forEach(part => {
      const chapterId = part.chapterId
      if (!groups[chapterId]) {
        groups[chapterId] = []
      }
      groups[chapterId].push(part)
    })
    return groups
  }

  const saveAndRefreshDuplicatedParts = async (
    projectId,
    chapterId,
    partsIds,
    headers,
  ) => {
    try {
      const { parts } = await API.post(SERVICE_PART_CORE, "/duplicate", {
        headers: headers,
        body: {
          projectID: projectId,
          chapterID: chapterId,
          partIDs: partsIds,
        },
      })

      dispatch({
        type: REMOVE_ALL_PARTS_FROM_CHAPTER,
        payload: {
          chapterId: chapterId,
        },
      })

      parts.forEach(p => {
        dispatch({
          type: "ADD_PARTIDA",
          payload: {
            chapterId: p.chapterId,
            partidaNueva: new Part({ partidaId: p }),
            tmpIndex: p.position + 1,
          },
        })
      })
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
      uncheckAll()
    } catch (error) {
      console.log(error)
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
      uncheckAll()
    }
  }

  const duplicateParts = async parts => {
    dispatch({
      type: "ON_UPDATE",
    })

    const headers = {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
      "Access-Control-Allow-Origin": "*",
    }

    const { projectId } = parts[0]

    const groupedParts = groupByChapterId(parts)

    for (const chapterId in groupedParts) {
      if (groupedParts.hasOwnProperty(chapterId)) {
        const partidas = groupedParts[chapterId]
        const partsIds = partidas.map(p => p.partidaId)

        saveAndRefreshDuplicatedParts(projectId, chapterId, partsIds, headers)
      }
    }
  }

  const exportToWord = async (partsIds, chaptersIds) => {
    try {
      let commonHeaders = getCommonHeaders()

      const body = {
        partsIds: partsIds,
        chaptersIds: chaptersIds,
      }

      const payload = {
        ...commonHeaders,
        body: body,
      }
      setTimeout(() => {
        dispatch({
          type: SET_LOADING_ICON,
          payload: {
            isLoading: false,
            index: null,
          },
        })
        uncheckAll()
      }, 6000)
      const resp = await API.post(SERVICE_CORE_BASE, "/exportPdf", payload)
    } catch (error) {
      console.log(error)
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
      uncheckAll()
    }
  }

  const exportToExcel = async (partsIds, chaptersIds) => {
    try {
      let commonHeaders = getCommonHeaders()
      const path =
        partsIds.length > 0 ? "/excel/s3/partidas" : "/excel/s3/chapters"

      const bodyStructure = {
        chapters: [],
        partidas: [],
        options: {
          cost_price: true,
          cost_real: true,
          client_price: true,
          decomposition: true,
          measures: true,
          comment: true,
          certifications: false,
          certification_id: "",
          debug: false,
        },
      }
      const body =
        partsIds.length > 0
          ? {
              ...bodyStructure,
              partidas: partsIds.map(p => p.partidaId),
            }
          : {
              ...bodyStructure,
              chapters: chaptersIds.map(c => c.chapterId),
            }

      const payload = {
        ...commonHeaders,
        body: body,
      }
      const resp = await API.post(SERVICE_CORE_BASE, path, payload)
      const link = document.createElement("a")
      link.style.display = "none"
      link.href = resp.url
      document.body.appendChild(link)
      link.click()

      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
      uncheckAll()
    } catch (error) {
      console.log(error)
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
      uncheckAll()
    }
  }
  const exportToPdf = async (partsIds, chaptersIds) => {
    try {
      let commonHeaders = getCommonHeaders()

      const hasParts = partsIds && partsIds.length > 0
      const hasChapters = chaptersIds && chaptersIds.length > 0

      const commonOptions = {
        briefing: {
          position: "top",
          depth: "chapters",
        },
        borderless: false,
        cover: true,
        conditions: false,
        currency: "EUR",
        decomposition: true,
        description: true,
        comment: true,
        envelope: true,
        footer: true,
        header: "simple",
        header_date: false,
        language: "es",
        logo: true,
        measures: true,
        mode: "price",
        price: "client",
        signature: false,
        certificationId: "",
      }

      let body
      let url

      if (hasParts) {
        body = {
          partidas: partsIds.map(p => p.partidaId),
          body: {
            options: commonOptions,
          },
        }
        url = `${partsIds[0].projectId}/partidas`
      } else if (hasChapters) {
        body = {
          chapters: chaptersIds.map(c => c.chapterId),
          body: {
            options: commonOptions,
          },
        }
        url = `${chaptersIds[0].projectId}/chapters`
      } else {
        throw new Error("Neither partsIds nor chaptersIds have data.")
      }

      const payload = {
        ...commonHeaders,
        body: body,
      }

      setTimeout(() => {
        dispatch({
          type: SET_LOADING_ICON,
          payload: {
            isLoading: false,
            index: null,
          },
        })
        uncheckAll()
      }, 6000)

      const resp = await API.post(
        SERVICE_CORE_BASE,
        `/pdf/project/s3/${url}`,
        payload,
      )

      const link = document.createElement("a")
      link.href = resp.url
      link.download = "archivo.pdf"
      link.click()
    } catch (error) {
      console.log(error)
      dispatch({
        type: SET_LOADING_ICON,
        payload: {
          isLoading: false,
          index: null,
        },
      })
      uncheckAll()
    }
  }

  const movePartsToChapter = async (partsChecked, chapterId, projectId) => {
    try {
      let commonHeaders = getCommonHeaders()
      const partsIds = partsChecked.map(part => part.partidaId)
      const body = {
        partIDs: partsIds,
        dstProjectID: projectId,
        dstChapterID: chapterId,
        move: true,
      }

      const payload = {
        ...commonHeaders,
        body: body,
      }

      const response = await API.post(
        SERVICE_CORE_BASE,
        "/partida/move_to",
        payload,
      )
      partsChecked.map(part => {
        dispatch({
          type: "ON_UPDATE",
        })
        dispatch({
          type: "DEL_PARTIDA",
          payload: {
            capituloId: part.chapterId,
            partidaId: part.partidaId,
          },
        })
      })
      dispatch({
        type: "ON_UPDATE",
      })
      dispatch({
        type: "DEL_CAPITULO",
        payload: { capituloId: response.chapterId },
      })
      dispatch({
        type: "ON_UPDATE",
      })
      const capituloInfo = {
        ...response,
        price: response.partidas.reduce(
          (acc, part) => acc + part.price * part.quantity,
          0,
        ),
        clientPrice: response.partidas.reduce(
          (acc, part) => acc + part.clientPrice * part.quantity,
          0,
        ),
        clientPriceWithoutDiscount: response.partidas.reduce(
          (acc, part) => acc + part.clientPriceWithoutDiscount * part.quantity,
          0,
        ),
      }
      dispatch({
        type: "ADD_CAPITULO",
        payload: {
          parentId: response.parentId,
          res: {
            ...response,
            capituloInfo: capituloInfo,
            price: response.partidas.reduce(
              (acc, part) => acc + part.price * part.quantity,
              0,
            ),
            clientPrice: response.partidas.reduce(
              (acc, part) => acc + part.clientPrice * part.quantity,
              0,
            ),
          },
          indexCapitulo: response.position,
        },
      })
      dispatch({
        type: "CLEAN_PARTS",
      })
    } catch (error) {
      console.log(error)
    }
  }

  const setLoadingIcon = data => {
    dispatch({
      type: SET_LOADING_ICON,
      payload: data,
    })
  }

  const closeBudgetExtras = async (projectId, tenderCloseQuery = null) => {
    dispatch({
      type: "ON_UPDATE",
    })
    try {
      const commonHeaders = await getCommonHeaders()
      const payload = {
        ...commonHeaders,
      }
      if (tenderCloseQuery) {
        payload.queryStringParameters = {
          priceReduced: tenderCloseQuery.priceReduced,
          reduction: tenderCloseQuery.reduction,
          clientPrice: tenderCloseQuery.clientPrice,
        }
      }
      const path = `/projects/${projectId}/close`
      const response = await API.get(SERVICE_CORE_BASE, path, payload)

      setCloseInfo(response.closeInfo)
      setIsBudgetClosed(response.is_closed)
    } catch (error) {
      console.log(error)
    }
  }

  const openBudgetExtras = async projectId => {
    dispatch({
      type: "ON_UPDATE",
    })
    try {
      let commonHeaders = getCommonHeaders()
      const payload = {
        ...commonHeaders,
      }
      const path = `/projects/${projectId}/open`
      const response = await API.get(SERVICE_CORE_BASE, path, payload)

      setIsBudgetClosed(response.is_closed)
    } catch (error) {
      console.log(error)
    }
  }

  const setIsBudgetClosed = isBudgetClosed => {
    dispatch({
      type: IS_BUDGET_CLOSED,
      payload: isBudgetClosed,
    })
  }

  const setCloseInfo = closeInfo => {
    dispatch({
      type: SET_CLOSE_INFO,
      payload: {
        clientPrice: closeInfo?.clientPrice ?? null,
        reducedPrice: closeInfo?.reducedPrice ?? null,
      },
    })
  }

  const setDynamicElementModalIsOpen = isOpen => {
    dispatch({
      type: SET_DYNAMIC_ELEMENT_MODAL_IS_OPEN,
      payload: isOpen,
    })
  }

  const setDynamicElementSelected = itemsSelected => {
    dispatch({
      type: SET_DYNAMIC_ELEMENT_SELECTED,
      payload: itemsSelected,
    })
  }

  const setDynamicElementProjectId = projectId => {
    dispatch({
      type: SET_DYNAMIC_ELEMENT_PROJECT_ID,
      payload: projectId,
    })
  }

  const setGeneralUpdate = update => {
    dispatch({
      type: SET_GENERAL_UPDATE,
      payload: update,
    })
  }

  const setChapterCertInProgress = inProgress => {
    chapterCertBatchActiveRef.current = inProgress
    if (inProgress) {
      chapterCertApiPendingCountRef.current = 0
    }
    dispatch({
      type: SET_CHAPTER_CERT_IN_PROGRESS,
      payload: inProgress,
    })
  }

  const notifyChapterCertApiStarted = () => {
    chapterCertApiPendingCountRef.current += 1
  }

  const notifyChapterCertApiCompleted = () => {
    chapterCertApiPendingCountRef.current = Math.max(
      0,
      chapterCertApiPendingCountRef.current - 1,
    )
    if (chapterCertApiPendingCountRef.current === 0) {
      chapterCertBatchActiveRef.current = false
      dispatch({
        type: SET_CHAPTER_CERT_IN_PROGRESS,
        payload: false,
      })
    }
  }

  const getChapterCertApiPendingCount = () =>
    chapterCertApiPendingCountRef.current

  const isChapterCertBatchActive = () => chapterCertBatchActiveRef.current

  const setCertDraftPartidaIncluded = (
    partidaId,
    included,
    draftMode = "total",
  ) => {
    dispatch({
      type: CERT_DRAFT_SET_PARTIDA,
      payload: { partidaId, included, draftMode },
    })
  }

  const setBudgetMode = budgetMode => {
    dispatch({
      type: "SET_BUDGET_MODE",
      payload: budgetMode,
    })
  }

  const setBaseCert = baseCert => {
    Chapter.setBaseCert(baseCert)

    if (state.budgetTree && state.budgetTree.subcapitulos) {
      for (const chapter of state.budgetTree.subcapitulos) {
        chapter.calculatePreviousTotalChapter()
        chapter.calculateCurrentTotalChapter()
      }
      state.budgetTree.calculateFooterValues()
    }

    dispatch({
      type: "SET_BASE_CERT",
      payload: baseCert,
    })
  }

  const setMarginModal = (open, projectId) => {
    dispatch({
      type: SET_MARGIN_MODAL,
      payload: {
        open: open,
        projectId: projectId,
      },
    })
  }

  return (
    <Budget2023Context.Provider
      value={{
        budgetTree: state.budgetTree,
        dynamicElement: {
          modalIsOpen: state.dynamicElement.modalIsOpen,
          setModalIsOpen: setDynamicElementModalIsOpen,
          selected: state.dynamicElement.selected,
          setSelected: setDynamicElementSelected,
          projectId: state.dynamicElement.projectId,
          setProjectId: setDynamicElementProjectId,
        },
        marginModal: {
          open: state.marginModal.open,
          setMarginModal: setMarginModal,
          projectId: state.marginModal.projectId,
          generalExpenses: state.marginModal.generalExpenses,
          indirectExpenses: state.marginModal.indirectExpenses,
          industrialProfit: state.marginModal.industrialProfit,
          discount: state.marginModal.discount,
          formula: state.marginModal.formula,
        },
        recalcBudget,
        reorderPartWithinChapter,
        deletePartDecomposition,
        loadingRecalc: state.loadingRecalc,
        loadingTree: state.loading,
        updating: state.updating,
        readyToClose: state.readyToClose,
        urlDownload: state.urlDownload,
        getBudgetTree,
        deleteCapitulo,
        deleteCapituloAndSetPosition,
        updateFinalPrice,
        deletePartidav2,
        createPartidaV2,
        addCapituloV2,
        updateIsExpanded,
        updatePartidav2,
        updateCertCurrent,
        clearCertification,
        updateCapitulov2,
        checkCapitulos,
        checkPartida,
        uncheckAll,
        closeBudget,
        isUpdates,
        downloadBudget,
        bc3Download,
        updatePreciosFinalesv2,
        addImageToPart,
        deleteImageFromPart,
        selectedBudget2: state.selectedBudget2,
        selectedPartGroup: state.selectedPartGroup,
        errorAgrupar: state.errorAgrupar,
        getSelectedBudget,
        selectPartsGroup,
        ExportToBankPrices,
        groupParts,
        changeSidebar: state.changeSidebar,
        detectChange,
        selectedChaptersGroup: state.selectedChaptersGroup,
        getSelectedBudget2,
        groupChapters,
        updatePartsList,
        partsChecked: state.partsChecked,
        chaptersChecked: state.chaptersChecked,
        changeCheck,
        imChecked: state.imChecked,
        imChecked2: state.imChecked2,
        checkMultipleParts,
        checkMultipleChapters,
        addToSelfManagement,
        getTagsByProject,
        tags: state.tags,
        saveTagsToFilter,
        tagsFiltered: state.tagsFiltered,
        closeEntireBudget,
        changeVersion,
        versionToDisplay: state.versionToDisplay,
        getVersionTree,
        updateChaptersList,
        changeCheck2,
        moveChapters,
        getSelectedChapters,
        cleanParts,
        cleanChapters,
        createPartsOnBudget,
        getSubCapitulosContent,
        getSubCapitulosContent2,
        exportBudget2BC3,
        getBudgetPDF,
        budgetPDF: state.budgetPDF,
        loadingBudgetPDF: state.loadingBudgetPDF,
        deleteMultipleParts,
        moveChaptersWithArrows,
        exportToTemplate,
        sendBudget,
        loadingSend: state.loadingSend,
        sendOk: state.sendOk,
        reset,
        loadingAgruparChapters: state.loadingAgruparChapters,
        loadingAgruparParts: state.loadingAgruparParts,
        copiedData: state.copiedData,
        copyBudgetData,
        lastActions: state.lastActions,
        undoAction,
        pdfDownload,
        pdfPreviewDownload,
        closeCertification,
        certDraftPartidaIds: state.certDraftPartidaIds,
        setCertDraftPartidaIncluded,
        setModalBudgetingError,
        modalBudgetingError: state.modalBudgetingError,
        duplicateParts,
        downloadCertification,
        downloadCertificationAtOriginXls,
        downloadCertificationAtOriginPdf,
        setIsContradictingPart,
        isContradictingPart: state.isContradictingPart,
        loadingIcon: state.loadingIcon,
        setLoadingIcon,
        exportToPdf,
        exportToWord,
        exportToExcel,
        movePartsToChapter,
        closeBudgetExtras,
        openBudgetExtras,
        isBudgetClosed: state.isBudgetClosed,
        setIsBudgetClosed,
        closeInfo: state.closeInfo,
        budgetMode: state.budgetMode,
        setBudgetMode,
        setBaseCert,
        baseCert: state.baseCert,
        certification: {
          generalUpdate: state.certification.generalUpdate,
          setGeneralUpdate: setGeneralUpdate,
          loading: state.certification.loading,
          chapterCertInProgress: state.certification.chapterCertInProgress,
          setChapterCertInProgress: setChapterCertInProgress,
          notifyChapterCertApiStarted,
          notifyChapterCertApiCompleted,
          getChapterCertApiPendingCount,
          isChapterCertBatchActive,
        },
        coefficients: state.coefficients,
      }}
    >
      {props.children}
    </Budget2023Context.Provider>
  )
}
Budget2023State.propTypes = {
  children: PropTypes.any.isRequired,
}
export default Budget2023State
